import { unitMapping } from '#src/lib/style.ts';

type Props = {
  size?: keyof typeof unitMapping;
  className?: string;
};

export const BaseballOutfielder = ({ size = 2, className }: Props) => (
  <svg
    className={className}
    style={{ width: unitMapping[size], height: unitMapping[size] }}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.16881 5.37988L8.02658 6.42312L7.47019 9.59145L6.2415 10.6347H3.56773L2.70996 9.59145L3.26635 6.42312L4.49505 5.37988H7.16881ZM5.75465 9.39826L6.17195 9.04279L6.5506 6.90996L6.31104 6.61631H4.98189L4.5646 6.97178L4.18594 9.10461L4.4255 9.39826H5.75465ZM13.0834 6.61631H10.1314L9.97685 7.47407H12.5424L12.3261 8.7105H9.76047L9.42046 10.6347H8.02948L8.9568 5.37988H13.2997L13.0834 6.61631Z"
      fill="white"
    />
  </svg>
);
